import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
import Adura from '../../components/assets/Adura.jpg';
import Titilope from '../../components/assets/Titilope.jpg';
import Ololade from '../../components/assets/Ololade.png';

const testimonials = [
  {
    name: 'Adura Kumapayi',
    role: 'CEO, Dura Foods Exports',
    image: Adura,
    testimony: 'The Foodstuff Export Masterclass was my starting point. Within 3 months of completing the program, I secured contracts with buyers in the UK and US.',
    rating: 5
  },
  {
    name: 'Ololade Opeyemi',
    role: 'Foodstuff Exporter in Poland',
    image: Ololade,
    testimony: 'The practical knowledge and network I gained from this masterclass are invaluable. The mentorship aspect particularly helped me navigate complex export challenges.',
    rating: 5
  },
  {
    name: 'Titilope Ibidun',
    role: 'CEO Fayfoods NG',
    image: Titilope,
    testimony: 'From understanding international food standards to making valuable connections, this has helped transformed my business both locally & internationally.',
    rating: 5
  }
];

const handleEnrollClick = () => {
    window.open('https://paystack.com/pay/femjune2025', '_blank');
  };

const FEMTestimonies = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl font-bold text-gray-900 sm:text-4xl"
          >
            Success Stories
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="mt-4 text-xl text-gray-600"
          >
            Hear from our alumni who are now successful food exporters
          </motion.p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              className="bg-white rounded-xl shadow-lg overflow-hidden"
            >
              <div className="p-8">
                <div className="flex items-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star
                      key={i}
                      className="h-5 w-5 text-yellow-400 fill-current"
                    />
                  ))}
                </div>

                <Quote className="h-8 w-8 text-green-600 mb-4" />

                <p className="text-gray-600 mb-6">
                  "{testimonial.testimony}"
                </p>

                <div className="flex items-center">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="h-12 w-12 rounded-full object-cover"
                  />
                  <div className="ml-4">
                    <h4 className="text-lg font-semibold text-gray-900">
                      {testimonial.name}
                    </h4>
                    <p className="text-gray-600">{testimonial.role}</p>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-16 bg-green-50 rounded-2xl p-8 text-center"
        >
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Join Our Success Stories
          </h3>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
            Take the first step towards becoming a successful food exporter. Our next cohort starts soon!
          </p>
          <button onClick={handleEnrollClick} className="px-8 py-4 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition-colors">
            Enroll in Masterclass
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default FEMTestimonies;